import React from "react";
import { Snackbar } from "@mui/material";

const Toast = ({ msg, open, ...props }) => {
  return <Snackbar open={open} {...props} message={msg} />;
};

export default Toast;
